import React, { useState, useEffect } from 'react'
import { TranslationContext } from './context'
import { useConfig } from '../config/use'
import axios from 'axios'

export const TranslationProvider = ({children}) => {
  const [resources, setResources] = useState();
  const [language, setLanguage] = useState('Svenska');
  const { state: { config }} = useConfig();
  useEffect(() => {
    async function GetResources() {
      await axios({
        method: 'get',
        url: './translations.json',
        responseType: 'json'
      })
      .then(res => {setResources(res.data);})
    }
    GetResources();
    var storedlang = localStorage.getItem('language');
    if (storedlang)
    {
      setLanguage(storedlang);
      document.documentElement.lang = storedlang;
    }
  }, [])

  useEffect(() => {
    if (config)
    {
      var storedlang = localStorage.getItem('language');
      if (storedlang)
      {
        setLanguage(storedlang);
        document.documentElement.lang = storedlang;
      }
      else
      {
        setLanguage(config.defaultLanguage);
        document.documentElement.lang = config.defaultLanguage;
        localStorage.setItem('language', config.defaultLanguage);
      }
    }
  }, [config])

  const t = text => {
    if (resources && language)
    {
      const splitted = text.split(".");
      if (splitted.length > 0)
      {
        var result = resources[language];
        try{
          for(var i = 0; i < splitted.length; i++)
          {
            result = result[splitted[i]]
          }
        }
        catch{
          return "Please fix your translation file"
        }
        return result
      }
    }
    return ""
  }

  const dt = (officeid, textname) => {
    if (resources && language)
    {
      const result = resources[language];
      try {
        var res = result["formspage"];
        var officetranslations = res["offices"].find(x => x.officeid === officeid);
        if (officetranslations)
        {
          var textobj = officetranslations["texts"].find(x => x.label === textname)
          if (textobj)
            return textobj.text;
        }
        else
        {
          var templatetext = result["formspage"]["templates"]["texts"].find(x => x.label === textname)
          if (templatetext)
            return templatetext.text;
        }
      }
      catch {
        console.error("Please fix your dynamic translations");
        return null;
      }
      console.error("Please fix your dynamic translations");
      return null;
    }
  }

  const updateLanguage = newlang => {
    if (resources && language)
    {
      var result = Object.keys(resources).find(x => x === newlang);
      if (result)
      {
        setLanguage(newlang);
        localStorage.setItem('language', newlang);
        document.documentElement.lang = newlang;
      }
    }
  }

  const value = {
    state: { resources },
    actions: {t, dt, updateLanguage}
  }

  return (
    <TranslationContext.Provider value = {value}>
      { children }
    </TranslationContext.Provider>
  )
}
